// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CbL4","title":"styles_title__1Eczx"};